import { render, staticRenderFns } from "./AboutComponent.vue?vue&type=template&id=55ff92c0&scoped=true"
import script from "./AboutComponent.vue?vue&type=script&lang=js"
export * from "./AboutComponent.vue?vue&type=script&lang=js"
import style0 from "./AboutComponent.vue?vue&type=style&index=0&id=55ff92c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff92c0",
  null
  
)

export default component.exports